export default __webpack_public_path__ + "static/media/hanzo-marked.079d5219.mp3";